import "../styles/info.scss";
import React, { MouseEventHandler } from "react";
import { Link, NavLink, Route, RouteComponentProps } from "react-router-dom";

import { Switch } from "react-router";
import { Oration } from "./infos/oration";
import { Orgnization } from "./infos/orgnization";

import { Publisher } from "./infos/publisher";
import { News } from "./infos/News";
import { PublishDetial } from "./infos/publishdetial";
import { withRouter } from "react-router-dom";
import { About } from "./infos/about";
//@ts-ignore
@withRouter
export class Info extends React.Component<Partial<RouteComponentProps>> {

    linkHandle: MouseEventHandler<HTMLAnchorElement> = (e) => {
        e.currentTarget.parentElement?.querySelectorAll("a").forEach((item) => { item.classList.remove("choiced") });
        e.currentTarget.className = "choiced";
        return true;
    }
    componentDidMount(): void {

    }
    render() {

        return (
            <section className="headerinfo info bg">
                <nav>
                    <div>
                        <NavLink to={"/views/infos/Oration"} activeClassName="choiced" onClick={this.linkHandle}>馆长致辞</NavLink>
                        <NavLink to={"/views/infos/Publisher"} activeClassName="choiced" onClick={this.linkHandle}>最新动态</NavLink>
                        <NavLink to={"/views/infos/about"} activeClassName="choiced" onClick={this.linkHandle}>关于我们</NavLink>
                        <NavLink to={"/views/infos/orgnization"} activeClassName="choiced" onClick={this.linkHandle}>组织架构</NavLink>
                        <NavLink to={"/views/infos/news"} activeClassName="choiced" onClick={this.linkHandle}>开放信息</NavLink>
                    </div>
                </nav>
                <div className="article">
                    <Switch>
                        <Route path={"/views/infos/Oration"} exact component={Oration}></Route>

                        <Route path={"/views/infos/about"} exact component={About}></Route>
                        <Route path={"/views/infos/orgnization"} exact component={Orgnization}></Route>
                        <Route path={"/views/infos/Publisher"} exact component={Publisher}></Route>
                        <Route path={"/views/infos/publishdetial/:id"} exact component={PublishDetial}></Route>
                        <Route path={"/views/infos/news"} exact component={News}></Route>

                    </Switch>
                </div>
            </section>
        );
    }
}